module.exports = __webpack_public_path__ + "img/Word Icon.eda30b8d.svg";